import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const LegalLayout = ({ title, updated, children }) => (
  <div className="min-h-screen bg-background">
    <Navbar />
    <main className="mx-auto max-w-3xl px-6 lg:px-10 pt-32 pb-24">
      <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
        <ArrowLeft className="h-4 w-4" /> Back to home
      </Link>
      <h1 className="mt-6 font-display text-3xl sm:text-4xl tracking-tight font-medium">{title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">Last updated: {updated}</p>
      <div className="mt-10 space-y-8 text-muted-foreground leading-relaxed [&_h2]:font-display [&_h2]:text-foreground [&_h2]:text-xl [&_h2]:font-medium [&_h2]:mb-3 [&_p]:text-base">
        {children}
      </div>
    </main>
    <Footer />
  </div>
);

export default LegalLayout;
